import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RoomHub } from '../../core/hub/room.hub';
import { MessageState } from '../../core/model/message.state';

@Component({
  selector: 'app-dialog-remove-room',
  templateUrl: './dialog-remove-room.component.html',
  styleUrls: ['./dialog-remove-room.component.scss']
})
export class DialogRemoveRoomComponent implements OnInit {
  roomId: string;
  isLoading = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogRemoveRoomComponent>,
    public roomHub: RoomHub) { }

  ngOnInit() {
    this.roomId = this.data.roomId;
  }

  removeRoom() {
    this.isLoading = true;
    this.roomHub.delete(this.roomId)
      .subscribe(res => {
        this.isLoading = false;
        this.dialogRef.close({ status: 'success' });
      },
        error => {
          this.isLoading = false;
          this.dialogRef.close(error);
        });
  }
}
